const CX = 200;
const CY = 200;
const R = 138;
const RINGS = [0.25, 0.5, 0.75, 1];

function point(index, radius, total = 10) {
  const angle = (Math.PI * 2 * index) / total - Math.PI / 2;
  return [CX + radius * Math.cos(angle), CY + radius * Math.sin(angle)];
}

const polygonPoints = (domains, scoreRadius = false) => domains
  .map((domain, index) => point(index, scoreRadius ? (domain.score / 100) * R : R * domain).join(","))
  .join(" ");

const labelAnchor = (x) => (x < CX - 8 ? "end" : x > CX + 8 ? "start" : "middle");

function RadarGrid({ domains, grid, axis }) {
  return (
    <>
      {RINGS.map((fraction) => (
        <polygon key={fraction} points={polygonPoints(Array(10).fill(fraction))} fill="none" stroke={grid} strokeWidth={fraction === 1 ? 1.4 : 1} strokeDasharray={fraction === 1 ? "none" : "3 4"} />
      ))}
      {domains.map((domain, index) => {
        const [x, y] = point(index, R);
        return <line key={domain.code} x1={CX} y1={CY} x2={x} y2={y} stroke={axis} strokeWidth={1} />;
      })}
    </>
  );
}

function RadarData({ domains }) {
  return (
    <>
      <polygon points={polygonPoints(domains, true)} fill="rgba(214,33,42,0.16)" stroke="#D6212A" strokeWidth={2} strokeLinejoin="round" />
      {domains.map((domain, index) => {
        const [x, y] = point(index, (domain.score / 100) * R);
        return <circle key={domain.code} cx={x} cy={y} r={3} fill="#D6212A" />;
      })}
    </>
  );
}

function RadarLabels({ domains, labelColor, scoreColor, labelSize }) {
  return domains.map((domain, index) => {
    const [x, y] = point(index, R + 26);
    return (
      <text key={domain.code} x={x} y={y} textAnchor={labelAnchor(x)} dominantBaseline="middle" style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: labelSize, letterSpacing: 1 }}>
        <tspan fill={labelColor}>{domain.code} </tspan>
        <tspan fill={scoreColor} fontWeight="700">{domain.score}</tspan>
      </text>
    );
  });
}

const RadarPulse = () => (
  <>
    <circle cx={CX} cy={CY} r={3.5} fill="#D6212A" />
    <circle cx={CX} cy={CY} r={3.5} fill="none" stroke="#D6212A" strokeWidth={1.5}>
      <animate attributeName="r" values="3.5;14" dur="2.2s" repeatCount="indefinite" />
      <animate attributeName="opacity" values="0.8;0" dur="2.2s" repeatCount="indefinite" />
    </circle>
  </>
);

export default function CpiRadar({ domains, dark = false, className = "", testId = "cpi-radar", ariaLabel = "Sample Clinical Performance Index radar across 10 physiological domains", labelSize = 11 }) {
  const grid = dark ? "rgba(255,255,255,0.18)" : "rgba(17,41,107,0.18)";
  const axis = dark ? "rgba(255,255,255,0.10)" : "rgba(17,41,107,0.10)";
  const labelColor = dark ? "rgba(255,255,255,0.75)" : "rgba(17,41,107,0.75)";
  const scoreColor = dark ? "#ffffff" : "#11296B";
  return (
    <svg viewBox="-28 -6 456 412" className={className} role="img" aria-label={ariaLabel} data-testid={testId}>
      <RadarGrid domains={domains} grid={grid} axis={axis} />
      <RadarData domains={domains} />
      <RadarLabels domains={domains} labelColor={labelColor} scoreColor={scoreColor} labelSize={labelSize} />
      <RadarPulse />
    </svg>
  );
}